import { render, staticRenderFns } from "./AiAssessmentsWrapper.vue?vue&type=template&id=54497128&scoped=true"
import script from "./AiAssessmentsWrapper.vue?vue&type=script&lang=ts"
export * from "./AiAssessmentsWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54497128",
  null
  
)

export default component.exports